import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedAdmin({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-checking">
        <p className="text-sm" style={{ color: "var(--jaf-text-muted)" }}>Loading…</p>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  if (!user.is_admin) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4" data-testid="not-admin">
        <div className="max-w-md text-center">
          <h1 className="font-serif text-3xl mb-2">Hmm — not quite.</h1>
          <p className="mb-6" style={{ color: "var(--jaf-text-muted)" }}>
            This Google account ({user.email}) doesn't have admin access.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
